import EditIcon from "@mui/icons-material/Edit";
import { Box, Button } from "@mui/material";
import { useState } from "react";
import DealerAddressContainer from "./DealerAddressContainer";
import EditAddressModal from "./EditAddressModal";
import FormattedAddress from "./FormattedAddress";
import { UpdateShipToAddressResponse } from "../../../../api/xtremeBff/xtremeBffInterfaces";
import LoadingIndicator from "../../../../components/LoadingIndicator/LoadingIndicator";
import { Address } from "../../types";
import NoDataAvailableError from "../NoDataAvailableError/NoDataAvailableError";

const DealerAddress = ({
  address,
  loading = false,
  title,
  editable = false,
  selectable = false,
  disableSelection = false,
  masked = false,
  orderNumber = "",
  accountId = "",
  updateAddress,
  isCleanserAddressValidationEnabled = false,
  isV2AddressValidationEnabled = false,
  setWarningEditModel,
}: {
  address: Address | undefined;
  loading?: boolean;
  title: string;
  editable?: boolean;
  selectable?: boolean;
  disableSelection?: boolean;
  masked?: boolean;
  orderNumber?: string;
  accountId?: string;
  updateAddress?: (res: UpdateShipToAddressResponse) => void;
  isCleanserAddressValidationEnabled?: boolean;
  isV2AddressValidationEnabled?: boolean;
  setWarningEditModel?: (value: boolean) => void;
}) => {
  const identifier = `${title.replace(/\s/g, "")}-order`;
  const [showEditAddress, setShowEditAddress] = useState(false);

  if (loading)
    return (
      <DealerAddressContainer title={title} identifier={identifier}>
        <LoadingIndicator />
      </DealerAddressContainer>
    );

  if (address === undefined)
    return (
      <DealerAddressContainer
        title={title}
        identifier={identifier}
        selectable={selectable}
        disableSelection={disableSelection}
        updateAddress={updateAddress}
      >
        <NoDataAvailableError />
      </DealerAddressContainer>
    );

  const closeModal = () => setShowEditAddress(false);

  return (
    <>
      <DealerAddressContainer
        title={title}
        identifier={identifier}
        selectable={selectable && !masked}
        disableSelection={disableSelection}
        updateAddress={updateAddress}
        currentAddress={address}
      >
        <FormattedAddress
          address={address}
          identifier={identifier}
          masked={masked}
        />
        {editable && (
          <Box>
            <Button
              size="small"
              variant="text"
              startIcon={<EditIcon />}
              onClick={() => setShowEditAddress(true)}
              data-testid={`${identifier}-edit-button`}
            >
              Edit
            </Button>
          </Box>
        )}
      </DealerAddressContainer>
      {editable && (
        <EditAddressModal
          open={showEditAddress}
          closeModal={closeModal}
          address={address}
          orderNumber={orderNumber}
          accountId={accountId}
          updateAddress={updateAddress!}
          isCleanserAddressValidationEnabled={
            isCleanserAddressValidationEnabled
          }
          isV2AddressValidationEnabled={isV2AddressValidationEnabled}
          setWarningEditModel={setWarningEditModel}
        />
      )}
    </>
  );
};

export default DealerAddress;
